export interface IClientStateContextSearchCriteria {
    firstName: string;
    lastName: string;
    email:string;
    eventTimeFromUtc:Date;
    eventTimeToUtc:Date;
    eventTimeFromLocal: Date;
    eventTimeToLocal: Date;
    isComplete:boolean;
}


export class ClientStateContextSearchCriteria implements IClientStateContextSearchCriteria {
    firstName: string;
    lastName: string;
    email:string;
    eventTimeFromUtc:Date;
    eventTimeToUtc:Date;
    eventTimeFromLocal: Date;
    eventTimeToLocal: Date;
    isComplete:boolean;
}